import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const title = css`
  color: ${colors.black};
  margin: 0px 15px 15px 0;
`;

export default {
  title,
};
